// The function address of the room this build belongs to.
// It comes from REACT_APP_FIREBASE_PROJECT_ID (the room settings); abc-saas-prod is the fallback.
const PROJECT = process.env.REACT_APP_FIREBASE_PROJECT_ID || "abc-saas-prod";
export const FUNCTIONS_BASE = `https://asia-south1-${PROJECT}.cloudfunctions.net`;
